// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"79acd88b","81":"d1618e10","787":"46f12491"}[chunkId] + ".chunk.js";
};